import dayjs, { Dayjs } from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

const LIMA_TZ = "America/Lima"

/** Accesos rápidos del filtro "Fecha y hora programada" de la tabla de puntos de entrega y recojo */
export type ScheduledPreset = "hoy" | "manana" | "mes"

export const SCHEDULED_PRESETS: { value: ScheduledPreset; label: string }[] = [
  { value: "hoy", label: "Hoy" },
  { value: "manana", label: "Mañana" },
  { value: "mes", label: "Este mes" }
]

const DAY_FORMAT = "YYYY-MM-DD"

/**
 * Rango de días (YYYY-MM-DD, ambos incluidos) de un acceso rápido, calculado con el día de Lima y no con el del navegador:
 * el back filtra `scheduledDateFrom`/`scheduledDateTo` por día de Lima. `now` se puede pasar para probarlo.
 */
export const scheduledPresetRange = (preset: ScheduledPreset, now: Dayjs = dayjs()): { from: string; to: string } => {
  const today = now.tz(LIMA_TZ)
  if (preset === "hoy") return { from: today.format(DAY_FORMAT), to: today.format(DAY_FORMAT) }
  if (preset === "manana") {
    const tomorrow = today.add(1, "day")
    return { from: tomorrow.format(DAY_FORMAT), to: tomorrow.format(DAY_FORMAT) }
  }
  return { from: today.startOf("month").format(DAY_FORMAT), to: today.endOf("month").format(DAY_FORMAT) }
}
